import { render, staticRenderFns } from "./look-xf.vue?vue&type=template&id=3482090f&scoped=true"
import script from "./look-xf.vue?vue&type=script&lang=js"
export * from "./look-xf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3482090f",
  null
  
)

export default component.exports